import { Component } from '@angular/core';
 
import { UserService } from './service/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { LoginService } from '../../../../components/login/service/login.service';
@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss'
})
export class UserManagementComponent {
  userName!: string;
  getUserList: any = [];
  getUser: any;
  sno!: number;
  userIndex!: number;
  show = false;
  showNewUser = false;
  showUserDetail = false;
  checkComp = '';
  findRole!: number;
  showSelectParent = false;
  getUserObject: any;
  spinner = false;
  getUserName!: string;
  sampleRestul: any;
  getUserId!: number;
  getUserId2!: number;
  spinnerSent: boolean = true;
  myOptions = {};
  myOptions2 = {};
  resetPasswordForm!: boolean;
  getValue!: string;
  showInput: boolean = false;
  selectedSortOption!: string;
  sortedBy = ['Sort by recent', 'Sort by name'];
  searchText!: string;
  userId!: string;
  userId2!: any;
  userId_temp: any;
  userSubscription:any;
  userDetails: any;

  constructor(private service:LoginService,private userService:UserService,private router:Router){}

  ngOnChanges() {
    if (this.findRole === 100 && 101) {
      this.showSelectParent = false;
    }
    if (this.findRole === 102) {
      this.showSelectParent = true;
    }
  }

  ngOnInit() {
       let user = localStorage.getItem("user");
        if(user){
          var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
            const userRole = JSON.parse(data);
            this.userId2 = userRole['userid'];
            this.userSubscription = userRole?.plan_id;
            if(this.userSubscription){
              if (this.getUserId2) {
                this.getIndexFun(this.getUserId2, 'user');
              } else {
                this.getIndexFun(1, 'user');
              }
            }else{
              this.getUserList2(this.userIndex, 'new');
            }
        }
    // this.userId = this.userDetailInput.userid.$oid;
  //  this.userId_temp = this.appComponent.userDetailsAppComp;
    //this.userId2 = this.userId_temp[0]?.userid;
    this.selectedSortOption = this.sortedBy[0];
 //   this.userDetails = this.appComponent.userDetailsAppComp;
  
    this.myOptions = {
      placement: 'top',
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
      theme: 'light',
    };
    this.myOptions2 = {
      placement: 'top',
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
    };
  }

  getIndexFun(sno: number, value: string) {
    this.spinner = true;
    this.userService.getUserList().subscribe({
      next:(sub:any) => {
        this.getUser = sub;
        this.spinner = false;
        this.getUserList2(sno, value);
        this.router.navigate(['main/postcall/userManagement/', sno]);
      },
      error:(error:HttpErrorResponse) => {
        console.log(error);
        this.spinner = false;
      }
  });
  }

  getUserList2(sno: number, value: string) {
    this.resetPasswordForm = !this.resetPasswordForm;
    this.getValue = value;
    if (value === 'user') {
      this.spinnerSent = true;
      this.getUserList = this.getUser?.user_list;
      if(this.getUserList && this.getUserList.length > 0){
        this.getUserId = this.getUserList.findIndex(
          (item: any) => item.sno === sno
        );
        this.findRole = this.getUserList?.[this.getUserId]?.role;
        this.getUserObject = this.getUserList[this.getUserId];
        this.getUserName = this.getUserList[this.getUserId]?.userid?.$oid;
        this.userIndex = this.getUserId;
        if (this.findRole === 100 || 101) {
          this.showSelectParent = false;
        }
        if (this.findRole === 102) {
          this.showSelectParent = true;
        }
      }

      this.spinner = false;
      this.spinnerSent = false;
    }
    this.checkComp = value;
    if (this.checkComp === 'new') {
      this.showUserDetail = true;
      this.showNewUser = false;
    }
    if (this.checkComp === 'user') {
      this.showNewUser = true;
      this.showUserDetail = false;
    }
  }

  sortUserName() {
    if (this.selectedSortOption === this.sortedBy[1]) {
      const a = this.getUserList.sort((a: any, b: any) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );
    }
    if (this.selectedSortOption === this.sortedBy[0]) {
      const sortedAsc = this.getUserList.sort(
        (objA: any, objB: any) =>
          new Date(objA.created_date).getTime() -
          new Date(objB.created_date).getTime()
      );
    }
  }

  receiveNewUserEmit(event: any) {
    this.checkComp = 'user';
    this.getUserList2(1, 'user');
  }

  backToUser(event:any){
    this.checkComp = event;
  }

  receiveDeleteUserEmit(data: any) {
    const index: number = this.getUserList.indexOf(data);
    this.getUserList.splice(index, 1);
    this.checkComp = 'new';
  }

  receiveNewUserData(user: object) {
    this.userService.getUserList().subscribe((sub) => {
      this.getUser = sub;
      this.getUserList = this.getUser?.user_list;
    });
  }

  showSearchField() {
    this.showInput = !this.showInput;
    this.searchText = '';
  }

}
